module.exports = __webpack_public_path__ + "img/hr.0d0d251a.svg";